import { UserService } from "user";
import { AppConfig, Redirection } from "common";
import { Router } from "@angular/router";
import { Injectable } from "@angular/core";
import { environment } from "@tytapp/environment";

@Injectable()
export class CommentsService {
    constructor(
        private userService: UserService,
        private appConfig: AppConfig,
        private redirection: Redirection,
        private router: Router
    ) {

    }

    private installed = false;

    install() {
        if (this.installed)
            return;
        this.installed = true;

        if (typeof document !== 'undefined') {
            document.addEventListener('spot-im-login-start', async () => {
                await this.userService.ready;
                let user = this.userService.user;

                if (user && user.entitled) {
                    alert(`Oops, you are already a logged in member. Please try refreshing the page to post your comment, and if this issue persists contact support at support@tytnetwork.com`);
                } else if (user && !user.entitled) {
                    this.redirection.go(environment.urls.purchase);
                } else {
                    this.router.navigateByUrl('/login');
                }

            }, false);
        }
    }
}